'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGdprConsentToCommunicateEnabled = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('./keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getGdprConsentToCommunicateEnabled = exports.getGdprConsentToCommunicateEnabled = (0, _getIn2.default)(_keyPaths.GDPR_CONSENT_TO_COMMUNICATE_ENABLED);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/message/getGdprConsentToCommunicateEnabled.js
// module id = 1067
// module chunks = 2 3